export const getFieldKeyName = (fieldName) => {
  switch (fieldName) {
    case 'Full Name':
      return 'fullName';

    case 'Birth Day':
      return 'birthday';

    case 'Physical Address':
      return 'physicalAddress';

    case 'City':
      return 'city';

    case 'Postal Code':
      return 'postalCode';

    case 'Phone Number':
      return 'phoneNumber';

    case 'Country':
      return 'buyerCountry';

    case 'Gender':
      return 'gender';

    case 'Company VAT Number':
      return 'companyVatNumber';

    case 'Company Name':
      return 'companyName';

  
    default:
      break;
  }
}